"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.CONSTANT = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _uiUtil = require("@ctmobile/ui-util");

var selectorPrefix = 'ct-scrolload-';
/**
 * ScrollLoad
 * @class ScrollLoad
 * @classdesc ScrollLoad
 */

var ScrollLoad =
/*#__PURE__*/
function () {
  /**
   * constructor
   * @constructor
   * @param {HtmlElement} el
   * @param {object} config
   * {
   *  @param {number} distance 属性允许配置距页面底部（以px为单位）的距离以触发无限滚动事件。默认情况下，如果未指定，则为50（px）
   * }
   */
  function ScrollLoad(el) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      distance: 50
    };
    (0, _classCallCheck2["default"])(this, ScrollLoad);
    this.el = el;
    this.scrollEl = this.el.querySelector(".".concat(selectorPrefix, "content"));
    this.loadEl = this.el.querySelector(".".concat(selectorPrefix, "load"));
    this.emptyEl = this.el.querySelector(".".concat(selectorPrefix, "empty"));
    this.errorEl = this.el.querySelector(".".concat(selectorPrefix, "error"));
    this.config = config; // 锁

    this.lock = false; // events

    this.events = new _uiUtil.Events();
    this.onScroll = this.onScroll.bind(this);
    this.onEmptyClick = this.onEmptyClick.bind(this);
    this.onErrorClick = this.onErrorClick.bind(this);
    this.scrollEl.addEventListener('scroll', this.onScroll);
    this.emptyEl.addEventListener('click', this.onEmptyClick);
    this.errorEl.addEventListener('click', this.onErrorClick);
  }
  /**
   * onScroll
   */


  (0, _createClass2["default"])(ScrollLoad, [{
    key: "onScroll",
    value: function onScroll() {
      var _this = this;

      var bottomHeight = this.scrollEl.scrollHeight - this.scrollEl.offsetHeight;
      var scrollTop = this.scrollEl.scrollTop;
      /**
       * 条件完全相等或误差值在1之间
       */

      if (this.events.hasType('scrollbottom') && Math.abs(scrollTop - bottomHeight) <= this.config.distance) {
        if (this.lock) return;
        this.lock = true; // 先显示loading

        this.loadEl.style.display = 'flex';
        this.events.trigger('scrollbottom', {
          /**
           * 完成
           * @param {string} status [empty(没有数据) | error(有错误) | normal(正常)]
           */
          done: function done(status) {
            _this.loadEl.style.display = 'none';

            if (status === ScrollLoad.EMPTY) {
              _this.emptyEl.style.display = 'block';
            } else if (status === ScrollLoad.ERROR) {
              _this.errorEl.style.display = 'block';
            }

            _this.lock = false;
          }
        });
      }
    }
    /**
     * onEmptyClick
     */

  }, {
    key: "onEmptyClick",
    value: function onEmptyClick() {
      if (this.events.hasType('emptyclick')) {
        this.events.trigger('emptyclick');
      }
    }
    /**
     * onErrorClick
     */

  }, {
    key: "onErrorClick",
    value: function onErrorClick() {
      if (this.events.hasType('errorclick')) {
        this.events.trigger('errorclick');
      }
    }
    /**
     * on 注册事件
     * @param {string} type
     *
     * 1.滚动到了底部 scrollbottom
     * 2.点击了没有数据 emptyclick
     * 3.点击了错误 errorclick
     *
     * @param {Function} handler
     */

  }, {
    key: "on",
    value: function on(type, handler) {
      this.events.on(type, handler);
    }
    /**
     * 删除指定type下的事件或清除所有
     * @param {string} type
     * @param {Function} handler
     */

  }, {
    key: "off",
    value: function off(type, handler) {
      if (type) {
        if (handler) {
          this.events.remove(type, handler);
        } else {
          this.events.clear(type);
        }
      } else {
        this.events.clearAll();
      }
    }
    /**
     * getLoadEl
     * @return {HtmlElement}
     */

  }, {
    key: "getLoadEl",
    value: function getLoadEl() {
      return this.loadEl;
    }
    /**
     * getEmptyEl
     * @return {HtmlElement}
     */

  }, {
    key: "getEmptyEl",
    value: function getEmptyEl() {
      return this.emptyEl;
    }
    /**
     * getErrorEl
     * @return {HtmlElement}
     */

  }, {
    key: "getErrorEl",
    value: function getErrorEl() {
      return this.errorEl;
    }
    /**
     * hideAll
     */

  }, {
    key: "hideAll",
    value: function hideAll() {
      this.loadEl.style.display = 'none';
      this.errorEl.style.display = 'none';
      this.emptyEl.style.display = 'none';
    }
  }]);
  return ScrollLoad;
}();

(0, _defineProperty2["default"])(ScrollLoad, "EMPTY", 'empty');
(0, _defineProperty2["default"])(ScrollLoad, "ERROR", 'error');
(0, _defineProperty2["default"])(ScrollLoad, "NORMAL", 'normal');
var CONSTANT = {
  EMPTY: ScrollLoad.EMPTY,
  ERROR: ScrollLoad.ERROR,
  NORMAL: ScrollLoad.NORMAL
};
exports.CONSTANT = CONSTANT;

/**
 * ScrollLoad
 * @param {HtmlElement} el
 * @param {object} config
 * @return {ScrollLoad}
 */
function _default(el, config) {
  return new ScrollLoad(el, config);
}